module.exports = __webpack_public_path__ + "joy-static/media/vertical-ribbon.c977563d.png";